import React from 'react'
import { styled } from '@mui/material/styles'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { CircleUserRound } from 'lucide-react'

import { Tooltip, Menu, MenuItem, IconButton as MuiIconButton } from '@mui/material'

import useAuth from '../../hooks/useAuth'

const IconButton = styled(MuiIconButton)`
    svg {
        width: 22px;
        height: 22px;
    }
`

function NavbarUserDropdown() {
    const { t } = useTranslation()
    const [anchorMenu, setAnchorMenu] = React.useState(null)
    const navigate = useNavigate()
    const { signOut } = useAuth()

    const toggleMenu = (event) => {
        setAnchorMenu(event.currentTarget)
    }

    const closeMenu = () => {
        setAnchorMenu(null)
    }

    const handleChangePassword = () => {
        closeMenu()
        navigate('/profile')
    }

    const handleSignOut = async () => {
        await signOut()
        navigate('/auth/sign-in')
    }

    return (
        <React.Fragment>
            <Tooltip title='Account'>
                <IconButton
                    aria-owns={anchorMenu ? 'menu-appbar' : undefined}
                    aria-haspopup='true'
                    onClick={toggleMenu}
                    color='inherit'
                    size='large'
                >
                    <CircleUserRound />
                </IconButton>
            </Tooltip>
            <Menu id='menu-appbar' anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeMenu}>
                <MenuItem onClick={handleChangePassword}>{t('site.auth.changePassword')}</MenuItem>
                <MenuItem onClick={handleSignOut}>{t('site.auth.logout')}</MenuItem>
            </Menu>
        </React.Fragment>
    )
}

export default NavbarUserDropdown
